import Vue from 'vue';
import Vuex from 'vuex';
import * as types from './mutation-types';
import 'es6-promise/auto';
import mediaContents from './module/mediaContents';
import waitMediaContents from './module/waitMediaContents';
import mediaContentsUpload from './module/mediaContentsUpload';
import waitMediaContentsUpload from './module/waitMediaContentsUpload';
import preview from './module/preview';
import schedule from './module/schedule';
import scheduleRegisterModal from './module/scheduleRegisterModal';
import scheduleRegisterModalContents from './module/scheduleRegisterModalContents';
import calendar from './module/calendar';

Vue.use(Vuex);

const store = new Vuex.Store({
    namespaced: true,
    modules: {
        media_contents: mediaContents,
        wait_media_contents: waitMediaContents,
        media_contents_upload: mediaContentsUpload,
        wait_media_contents_upload: waitMediaContentsUpload,
        preview,
        schedule,
        schedule_register_modal: scheduleRegisterModal,
        schedule_register_modal_contents: scheduleRegisterModalContents,
        calendar,
    },
    state: {
        selected_service_account: {},
        cpk_for_logging_check: localStorage.getItem('cpkForLoggingCheck') || '',
        login_account: {},
        service_accounts: [],
        have_service_account: true,
        login_account_role: null,
        menu_toggle: true,
        player_snapshot: {},
        pusher: {},
        google_config: {},
        selected_service_account_contract: {},
        have_service_account_contract: true,
        location: 'console',
        config: {},
        selected_service_account_additional_info: {},
    },
    getters: {
        selectedServiceAccount: state => state.selected_service_account,
        getCpkForLoggingCheck: state => state.cpk_for_logging_check, // 로그파일에 키 변경기록을 수행한 content provider key
        getServiceAccounts: state => state.service_accounts,
        getLoginAccount: state => state.login_account,
        getMenuToggle: state => state.menu_toggle,
        getLoginAccountRole: state => state.login_account_role,
        haveServiceAccount: state => state.have_service_account,
        getPusher: state => state.pusher,
        getGoogleConfig: state => state.google_config,
        haveServiceAccountContract: state => state.have_service_account_contract,
        selectedServiceAccountContract: state => state.selected_service_account_contract,
        getConfig: state => state.config,
        selectedServiceAccountAdditionalInfo: state => state.selected_service_account_additional_info,
    },
    mutations: {
        [types.SELECT_SERVICE_ACCOUNT]: (state, payload) => {
            state.selected_service_account = payload.service_account;
        },
        [types.SET_SPK_FOR_LOGGING_CHECK]: (state, payload) => {
            state.cpk_for_logging_check = payload.cpk_for_logging_check;
            localStorage.setItem('cpkForLoggingCheck', payload.cpk_for_logging_check);
        },
        [types.SET_LOGIN_ACCOUNT]: (state, payload) => {
            state.login_account = payload.login_account;
        },
        [types.SET_SERVICE_ACCOUNTS]: (state, payload) => {
            state.service_accounts = payload.service_accounts;
        },
        [types.SET_MENU_TOGGLE]: (state, payload) => {
            state.menu_toggle = payload.menu_toggle;
        },
        [types.HAVE_SERVICE_ACCOUNT]: (state, payload) => {
            state.have_service_account = payload.have_service_account;
        },
        [types.LOGIN_ACCOUNT_ROLE]: (state, payload) => {
            state.login_account_role = payload.login_account_role;
        },
        [types.SET_PLAYER_SNAPSHOT]: (state, payload) => {
            state.player_snapshot = payload;
        },
        [types.SET_PUSHER]: (state, payload) => {
            state.pusher = payload.pusher;
        },
        [types.SET_GOOGLE_CONFIG]: (state, payload) => {
            state.google_config = payload.google_config;
        },
        [types.HAVE_SERVICE_ACCOUNT_CONTRACT]: (state, payload) => {
            state.have_service_account_contract = payload.have_service_account_contract;
        },
        [types.LOCATION]: (state, payload) => {
            state.location = payload.location;
        },
        [types.SET_CONFIG]: (state, payload) => {
            state.config = payload.config;
        },
        [types.SELECT_SERVICE_ACCOUNT_CONTRACT]: (state, payload) => {
            state.selected_service_account_contract = payload.contract;
        },
        [types.SELECT_SERVICE_ACCOUNT_ADDITIONAL_INFO]: (state, payload) => {
            state.selected_service_account_additional_info = payload.additional_info;
        },
    },
    actions: {
        changeMenuToggle({ commit }, payload) {
            commit(types.SET_MENU_TOGGLE, payload);
        },
        async setCpkForLoggingCheck({ state, commit }, payload) {
            await axios.post('/cms/account/selected_service_account', { selected_service_account_key: payload.cpk_for_logging_check }).then((response) => {
                commit(types.SET_SPK_FOR_LOGGING_CHECK, { cpk_for_logging_check: payload.cpk_for_logging_check });
            });
        },
        async changeServiceAccount({ dispatch, commit, state }, payload) {
            // 서비스어카운트 변경 로깅처리
            // location 이 creator 일 때 제외.
            const isChanged = state.location !== 'creator' &&
                state.cpk_for_logging_check !== payload.service_account.key;
            if (isChanged) { // 로그파일에 동일한 서비스어카운트 선택이력이 연속되어 중복기록되는 경우를 방지하기 위해 체크함
                await dispatch('setCpkForLoggingCheck', { cpk_for_logging_check: payload.service_account.key });
            }
            await commit(types.SELECT_SERVICE_ACCOUNT, payload);
            await dispatch('loadContract');
            if (state.login_account_role === null) {
                // Vue.$log.debug(state.login_account_role, payload.service_account.role);
                commit(types.LOGIN_ACCOUNT_ROLE, { login_account_role: payload.service_account.role });
            }
        },
        setHaveServiceAccount({ commit }, payload) {
            commit(types.HAVE_SERVICE_ACCOUNT, payload);
        },
        setHaveServiceAccountContract({ commit }, payload) {
            commit(types.HAVE_SERVICE_ACCOUNT_CONTRACT, payload);
        },
        async selectServiceAccount({ dispatch, commit, state }) {
            if (state.service_accounts.length === 0) {
                await dispatch('loadAccount');
            }
            if (typeof state.selected_service_account.key === 'undefined') {
                // const storedServiceAccount = localStorage.getItem('serviceAccount');
                let storedServiceAccount = state.cpk_for_logging_check;
                let serviceAccount;
                if (storedServiceAccount !== '') { // 로그인 후 cpk가 로그파일에 기록된 적 있는 경우
                    localStorage.setItem('serviceAccount', state.cpk_for_logging_check);
                } else {
                    storedServiceAccount = localStorage.getItem('serviceAccount');
                }

                if (!_.isEmpty(storedServiceAccount)) {
                    await axios.get(`/cms/account/service_accounts?key=${storedServiceAccount}`).then((response) => {
                        if (response.data.data && (response.data.data.length > 0)) {
                            serviceAccount = response.data.data[0];
                        }
                    });

                    // serviceAccount = _.find(state.selected_service_accounts, sa => sa.key === storedServiceAccount);
                }

                if (typeof serviceAccount === 'undefined') {
                    serviceAccount = _.head(state.service_accounts);
                    localStorage.setItem('serviceAccount', serviceAccount.key);
                }
                commit(types.LOCATION, { location: 'console' });

                dispatch('changeServiceAccount', { service_account: serviceAccount });
                // Vue.$log.info('store - selectServiceAccount', serviceAccount);
            }
        },
        async loadContract({ dispatch, commit, state }, payload) {
            if (typeof state.selected_service_account.key === 'undefined') {
                return;
            }
            let path = `/cms/${state.selected_service_account.key}/contract`;
            if (state.location === 'creator') {
                path = '/cms/creator/contract';
            }
            const { selected_service_account: currentServiceAccount } = state;
            await axios.get(path).then((response) => {
                currentServiceAccount.contract = response.data.data;
                const serviceAccountInfo = response.data.service_account;
                if (_.isEmpty(currentServiceAccount.contract)) {
                    dispatch('setHaveServiceAccountContract', { have_service_account_contract: false });
                }
                commit(types.SELECT_SERVICE_ACCOUNT_CONTRACT, { contract: currentServiceAccount.contract });
                commit(types.SELECT_SERVICE_ACCOUNT_ADDITIONAL_INFO, { additional_info: serviceAccountInfo });
            });
        },
        async loadAccount({ dispatch, commit, state }) {
            logger.warn('store - loadAccount');
            await axios.get('/cms/account').then((response) => {
                commit(types.SET_CONFIG, response.data.data);
                commit(types.SET_LOGIN_ACCOUNT, response.data.data);
                commit(types.SET_SERVICE_ACCOUNTS, response.data.data);
                commit(types.LOGIN_ACCOUNT_ROLE, { login_account_role: response.data.data.login_account.role });
                commit(types.SET_PUSHER, response.data.data);
                commit(types.SET_GOOGLE_CONFIG, response.data.data);

                if (state.service_accounts.length === 0) {
                    dispatch('setHaveServiceAccount', { have_service_account: false });
                }

                logger.warn(response.data);
            });
        },
        async loadCreatorServiceAccount({ dispatch, commit, state }) {
            logger.warn('store - loadCreatorServiceAccount');
            if (state.service_accounts.length === 0) {
                await dispatch('loadCreatorAccount');
            }


            if (typeof state.selected_service_account.key === 'undefined') {
                const storedServiceAccount = localStorage.getItem('serviceAccount');
                let serviceAccount;

                if (!_.isEmpty(storedServiceAccount)) {
                    serviceAccount = _.find(state.service_accounts, sa => sa.key === storedServiceAccount);
                }

                if (typeof serviceAccount === 'undefined') {
                    serviceAccount = _.head(state.service_accounts);
                    localStorage.setItem('serviceAccount', serviceAccount);
                }
                commit(types.LOCATION, { location: 'creator' });

                dispatch('changeServiceAccount', { service_account: serviceAccount });
                // Vue.$log.info('store - selectServiceAccount', serviceAccount);
            }
        },
        async loadCreatorAccount({ dispatch, commit, state }) {
            logger.warn('store - loadCreatorAccount');
            await axios.get('/cms/creator/account').then((response) => {
                commit(types.SET_LOGIN_ACCOUNT, response.data.data);
                commit(types.SET_SERVICE_ACCOUNTS, response.data.data);
                commit(types.LOGIN_ACCOUNT_ROLE, { login_account_role: response.data.data.login_account.role });
                commit(types.SET_PUSHER, response.data.data);
                commit(types.SET_GOOGLE_CONFIG, response.data.data);

                if (state.service_accounts.length === 0) {
                    dispatch('setHaveServiceAccount', { have_service_account: false });
                }
            });
        },
        setPlayerSnapshot({ commit }, payload) {
            console.log(payload);
            commit(types.SET_PLAYER_SNAPSHOT, payload);
        },
    },
});

export default store;
